import MasterLayout from "@/layouts/master";
export default [{
    path: "/apps",
    component: MasterLayout,
    children: [{
        path: "sms",
        name: "apps.sms",
        component: () =>
            import ("@/views/apps/sms/index.vue")
    }]
}]